// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2LyOh","head":"Table_head__AJrXu","col":"Table_col__1dtco"};